import React, { useState } from 'react';
import { ChevronDown, Phone, ArrowUp } from 'lucide-react';

const WhereWeUse = () => {
  const [activeTab, setActiveTab] = useState('Startups');

  const tabs = ['Startups', 'Small & Medium Enterprises', 'Large Enterprises'];

  // Use hex codes and style attribute for background colors
  const tabContent = {
    'Startups': {
      title: 'Start Small, Dream Big',
      description: "Let it be ten or twenty; don't hold back from wearing all your hats. Office24by7's integrated CRM and ERP solutions are designed for dreamers like you. Streamline sales process without question, manage customer relationships proactively, and gain real-time insights into your business performance. Enough with manual processes, leverage technology for what matters the most: growth.",
      bgColor: '#ff9800', // orange
      image: 'https://ik.imagekit.io/kqumni8l2/office%2024%207/office%2024%207/PartneredSolutions-mobileimg.webp?updatedAt=1754291725700'
    },
    'Small & Medium Enterprises': {
      title: 'Scale Smart, Grow Fast',
      description: "Ready to take your business to the next level? Office24by7's comprehensive suite of tools helps SMEs optimize operations, enhance customer experiences, and drive sustainable growth. From automated workflows to advanced analytics, we provide the foundation you need to compete with larger enterprises while maintaining your agility.",
      bgColor: '#3b82f6', // blue
      image: 'https://ik.imagekit.io/kqumni8l2/office%2024%207/office%2024%207/Scale-at-ease-mobileimg.webp?updatedAt=1754291725515'
    },
    'Large Enterprises': {
      title: 'Enterprise Excellence',
      description: "Transform your enterprise operations with Office24by7's robust, scalable solutions. Built for complexity, designed for efficiency. Our enterprise-grade platform integrates seamlessly with your existing infrastructure, providing advanced security, compliance features, and the reliability your organization demands. Lead your industry with confidence.",
      bgColor: '#059669', // green
      image: 'https://ik.imagekit.io/kqumni8l2/office%2024%207/office%2024%207/24x7CustomerSupport-mobileimg.webp?updatedAt=1754291725711'
    }
  };

  return (
    <div className="py-12 lg:py-20 bg-gray-50">
      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-2 sm:px-2 lg:px-3 py-2">
        {/* Hero Section */}
        <div className="text-center mb-6">
          <h1 className="text-3xl md:text-2xl lg:text-3xl font-bold" style={{ color: '#242222' }}>
            Get Closer to Success With Office24by7
          </h1>
          <p className="text-lg md:text-lg max-w-2xl mx-auto" style={{ color: '#322d2d' }}>
            Everyday is a new opportunity with Office24by7— no matter what industry, 
            scale of your business, or size of teams you have.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex flex-wrap justify-center mb-8">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-2 py-2 mx-2 mb-2 rounded-full font-medium transition-all duration-300 ${
                activeTab === tab
                  ? 'shadow-lg'
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
              style={
                activeTab === tab
                  ? { backgroundColor: '#2563eb', color: '#fff' }
                  : {}
              }
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Image Section */}
            <div className="lg:w-1/2">
              <img
                src={tabContent[activeTab].image}
                alt={activeTab}
                className="w-full h-full lg:h-full object-cover"
              />
            </div>

            {/* Content Section */}
            <div
              className="lg:w-1/2 p-3 lg:p-4 flex items-center"
              style={{ backgroundColor: tabContent[activeTab].bgColor }}
            >
              <div className="text-white">
                <h2 className="text-xl md:text-xl font-bold mb-3">
                  {tabContent[activeTab].title}
                </h2>
                <p className="text-md md:text-md leading-relaxed">
                  {tabContent[activeTab].description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default WhereWeUse;